export default "__VITE_ASSET__BwWFnhIY__"